import * as React from "react";
import {Link} from "react-router-dom";

import "./done-step.scss";
import "./mock-print.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {Load2}          from "@Common/react/load2";
import {unique}         from "@Common/utils/collections";
import {chain}          from "@Common/utils/fs";
import {parseUrlQuery}  from "@Common/utils/parse-url-query";

import {loadCustomizeRoute} from "../../load-customize-route";

import {DownloadLinks} from "./download-links/download-links";
import {PreloadImages} from "./preload-images";
import {PrintService}  from "./print-service/print-service";
import {Receipt}       from "./receipt/receipt";

export const DoneStep = ({match, location}) => cs(
    consumeContext("apis"),
    ["cart", ({apis}, next) => Load2({
        fetch: () => apis.next.cart.getCart(match.params.cart_id),
        next,
    })],
    ["printService", (_, next) => PrintService({next})],
    ({}, next) => loadCustomizeRoute({next,}),
    ["query", (_, next) => next(parseUrlQuery(location.search))],
    ["downloadLinks", ({cart}, next) => DownloadLinks({cart, next})],
    ({}, next) => (
        <div className="done-step-46q">
            <div className="card">
                {next()}
            </div>
        </div>
    ),
    ["tryTriggeringAiSurvey", ({}, next) => next(() => {
        const aiInteractionCount = Number(sessionStorage.getItem("aiInteractionCount"));
        if (aiInteractionCount >= 3) {
            hj("event", "trigger_ai_survey");
        }
    })],
    (({tryTriggeringAiSurvey}, next) => next(tryTriggeringAiSurvey())),

    ({cart, query, printService, downloadLinks}) => <>

        <div className="title" xd-qa-type="label" xd-qa-name="Checkout Complete">
            Checkout Complete
        </div>

        <div className="content">

            <div className="big-checkbox">
                <div className="circle">
                    <img alt="checkmark" src={require("../../../common/check.svg")} xd-qa-type="image" xd-qa-name="Checkmark"/>
                </div>
            </div>

            <div className="thank-you" xd-qa-type="label" xd-qa-name="Thank You">
                Thank you for ordering with Xpressdocs.
            </div>

            <div className="messages">
                <div className="message" xd-qa-type="label" xd-qa-name="Processing Now">
                    We are processing your order now!
                </div>
            </div>

            <div className="cart-summary">
                <div className="cart-no" xd-qa-type="label" xd-qa-name="Cart Number">
                    Cart Number: #<span xd-qa-type="label" xd-qa-name="Cart ID">{cart?.cartId || cart?.value?.cartId || "--"}</span>
                </div>
                <div className="products">
                    {cart.value?.items.map((item, i) => (
                        <div className="order" key={item.itemId} xd-qa-type="label" xd-qa-name={"Order "+i}>
                            <strong>{item.itemName || item.metaData?.productName || "Brochure"}</strong>:{" "}
                            Order #
                            <span xd-qa-type="label" xd-qa-name={"Order ID "+i}>
                                {item.itemId}
                            </span>
                            {item.shipping && item.shipping.estimatedDeliveryMessage && (
                                <span xd-qa-type="label" xd-qa-name={"Arrival "+i}>
                                    , <strong>Estimated arrival:</strong> {item.shipping.estimatedDeliveryMessage}
                                </span>
                            )}

                            {downloadLinks.render(item)}
                        </div>
                    ))}
                </div>
            </div>

            <div className="contact" xd-qa-type="label" xd-qa-name="Contact Info">
                Questions?{" "}
                <a
                    href={`tel:(866) 977-3627`}
                    xd-qa-type="link"
                    xd-qa-name="XD Phone"
                >
                    (866) 977-3627
                </a>
            </div>
        </div>

        <div className="footer">
            {cs(
                ({}, next) => cart.value && next(),
                ["preloadImages", ({}, next) => PreloadImages({
                    images: chain(
                        cart.value?.items.map((i) => i.itemThumbnails?.[0]).filter(v=>v),
                        unique,
                    ),
                    next,
                })],
                ({preloadImages}) => preloadImages.ready && (
                    <a
                        onClick={() => printService.print(
                            Receipt({cart: cart.value})
                        )}
                    >Print Receipt</a>
                ),
            )}

            {query?.referrer === "approval-requests" ? (
                <Link to="/account/orders/approval" xd-qa-type="link" xd-qa-name="Return to Dashboard">
                    Return to Dashboard
                </Link>
            ) : (
                <Link to={"/"} xd-qa-type="link" xd-qa-name="Continue Shopping">
                    Continue Shopping
                </Link>
            )}

        </div>
    </>
);
